// Mock data for ENFERNO - unified fitness app (Fitbod + Gravl)

export const userProfile = {
  name: 'Alex Carter',
  handle: '@alexcarter',
  avatar: 'https://images.unsplash.com/photo-1640262653851-103cbaf802d5?crop=entropy&cs=srgb&fm=jpg&w=200',
  streak: 23,
  totalWorkouts: 142,
  totalRides: 38,
  weeklyGoal: 5,
  weeklyDone: 4,
};

export const heroImages = {
  strength: '/generated/hero-strength.png',
  cycling: '/generated/recovery-cycling.png',
  dumbbellRed: '/generated/hero-moody.png',
  kettlebell: '/generated/hero-moody.png',
  rack: '/generated/hero-rack.png',
  gps: '/generated/hero-gps.png',
  stretch: '/generated/hero-stretch.png',
  dumbbellBW: '/generated/hero-moody.png',
  moodyDumbbells: '/generated/hero-moody.png',
};

export const todayWorkout = {
  id: 'wk-001',
  title: 'Upper Body Strength',
  duration: 52,
  intensity: 'High',
  muscles: ['Chest', 'Shoulders', 'Triceps'],
  generatedBy: 'Enferno AI',
  exercises: [
    { id: 'e1', name: 'Barbell Bench Press', sets: 4, reps: '6-8', weight: 185, rest: 120, muscle: 'Chest', equipment: 'Barbell', completed: false, image: 'https://images.unsplash.com/photo-1734630341082-0fec0e10126c?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
    { id: 'e2', name: 'Incline Dumbbell Press', sets: 3, reps: '8-10', weight: 65, rest: 90, muscle: 'Chest', equipment: 'Dumbbells', completed: false, image: 'https://images.pexels.com/photos/16080056/pexels-photo-16080056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=400' },
    { id: 'e3', name: 'Overhead Shoulder Press', sets: 4, reps: '6-8', weight: 95, rest: 120, muscle: 'Shoulders', equipment: 'Barbell', completed: false, image: 'https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
    { id: 'e4', name: 'Lateral Raises', sets: 3, reps: '12-15', weight: 20, rest: 60, muscle: 'Shoulders', equipment: 'Dumbbells', completed: false, image: 'https://images.pexels.com/photos/7690454/pexels-photo-7690454.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=400' },
    { id: 'e5', name: 'Tricep Rope Pushdown', sets: 3, reps: '10-12', weight: 50, rest: 60, muscle: 'Triceps', equipment: 'Cable', completed: false, image: 'https://images.unsplash.com/photo-1578762560042-46ad127c95ea?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
    { id: 'e6', name: 'Skull Crushers', sets: 3, reps: '8-10', weight: 60, rest: 75, muscle: 'Triceps', equipment: 'EZ Bar', completed: false, image: 'https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  ],
};

export const exerciseLibrary = [
  { id: 'lib-1', name: 'Barbell Squat', muscle: 'Legs', equipment: 'Barbell', difficulty: 'Advanced', image: 'https://images.unsplash.com/photo-1734630341082-0fec0e10126c?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  { id: 'lib-2', name: 'Deadlift', muscle: 'Back', equipment: 'Barbell', difficulty: 'Advanced', image: 'https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  { id: 'lib-3', name: 'Pull Up', muscle: 'Back', equipment: 'Bodyweight', difficulty: 'Intermediate', image: 'https://images.pexels.com/photos/16080056/pexels-photo-16080056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=400' },
  { id: 'lib-4', name: 'Romanian Deadlift', muscle: 'Hamstrings', equipment: 'Barbell', difficulty: 'Intermediate', image: 'https://images.pexels.com/photos/7690454/pexels-photo-7690454.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=400' },
  { id: 'lib-5', name: 'Bulgarian Split Squat', muscle: 'Legs', equipment: 'Dumbbells', difficulty: 'Intermediate', image: 'https://images.unsplash.com/photo-1578762560042-46ad127c95ea?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  { id: 'lib-6', name: 'Kettlebell Swing', muscle: 'Full Body', equipment: 'Kettlebell', difficulty: 'Beginner', image: 'https://images.unsplash.com/photo-1578762560042-46ad127c95ea?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  { id: 'lib-7', name: 'Cable Row', muscle: 'Back', equipment: 'Cable', difficulty: 'Beginner', image: 'https://images.unsplash.com/photo-1734630341082-0fec0e10126c?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  { id: 'lib-8', name: 'Hip Thrust', muscle: 'Glutes', equipment: 'Barbell', difficulty: 'Intermediate', image: 'https://images.pexels.com/photos/7690454/pexels-photo-7690454.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=400' },
  { id: 'lib-9', name: 'Plank', muscle: 'Core', equipment: 'Bodyweight', difficulty: 'Beginner', image: 'https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  { id: 'lib-10', name: 'Face Pull', muscle: 'Shoulders', equipment: 'Cable', difficulty: 'Beginner', image: 'https://images.pexels.com/photos/16080056/pexels-photo-16080056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=400' },
  { id: 'lib-11', name: 'Goblet Squat', muscle: 'Legs', equipment: 'Dumbbell', difficulty: 'Beginner', image: 'https://images.unsplash.com/photo-1734630341082-0fec0e10126c?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
  { id: 'lib-12', name: 'Dips', muscle: 'Chest', equipment: 'Bodyweight', difficulty: 'Intermediate', image: 'https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&w=400&q=80' },
];

export const activities = [
  {
    id: 'act-1',
    title: 'Sunrise Gravel Loop',
    type: 'Gravel Ride',
    date: 'Today, 6:42 AM',
    distance: 42.6,
    duration: '2h 14m',
    elevation: 1240,
    avgSpeed: 19.1,
    maxSpeed: 48.3,
    calories: 1820,
    location: 'Marin Headlands, CA',
    likes: 24,
    comments: 6,
    cover: 'https://images.unsplash.com/photo-1675213442168-3b1bf6131728?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  },
  {
    id: 'act-2',
    title: 'Lunch Recovery Spin',
    type: 'Road Ride',
    date: 'Yesterday, 12:30 PM',
    distance: 18.2,
    duration: '52m',
    elevation: 320,
    avgSpeed: 21.0,
    maxSpeed: 38.6,
    calories: 640,
    location: 'Golden Gate Park',
    likes: 12,
    comments: 2,
    cover: 'https://images.unsplash.com/photo-1633230329619-70ae2e6d50bb?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  },
  {
    id: 'act-3',
    title: 'Mt. Tam Climb',
    type: 'Gravel Ride',
    date: 'Sat, 7:10 AM',
    distance: 56.4,
    duration: '3h 48m',
    elevation: 2180,
    avgSpeed: 14.8,
    maxSpeed: 52.1,
    calories: 2640,
    location: 'Mt. Tamalpais',
    likes: 58,
    comments: 11,
    cover: 'https://images.unsplash.com/photo-1675213442168-3b1bf6131728?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  },
  {
    id: 'act-4',
    title: 'Evening Trail Run',
    type: 'Run',
    date: 'Thu, 6:15 PM',
    distance: 8.4,
    duration: '48m',
    elevation: 410,
    avgSpeed: 10.5,
    maxSpeed: 14.2,
    calories: 720,
    location: 'Tilden Park',
    likes: 18,
    comments: 3,
    cover: 'https://images.unsplash.com/photo-1640262653851-103cbaf802d5?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
  },
];

export const weeklyStats = [
  { day: 'Mon', strength: 45, cardio: 0 },
  { day: 'Tue', strength: 0, cardio: 52 },
  { day: 'Wed', strength: 60, cardio: 0 },
  { day: 'Thu', strength: 0, cardio: 48 },
  { day: 'Fri', strength: 55, cardio: 0 },
  { day: 'Sat', strength: 0, cardio: 228 },
  { day: 'Sun', strength: 50, cardio: 0 },
];

export const muscleRecovery = [
  { name: 'Chest', recovery: 95, color: '#22c55e' },
  { name: 'Back', recovery: 60, color: '#eab308' },
  { name: 'Legs', recovery: 30, color: '#ef4444' },
  { name: 'Shoulders', recovery: 80, color: '#22c55e' },
  { name: 'Arms', recovery: 45, color: '#f97316' },
  { name: 'Core', recovery: 70, color: '#eab308' },
];

export const features = [
  {
    title: 'AI Workout Engine',
    description: 'Personalized strength workouts that adapt to your recovery, equipment, and goals in real-time.',
    icon: 'Brain',
  },
  {
    title: 'Smart Exercise Library',
    description: 'Over 700 exercises with form cues, demos, and equipment alternatives.',
    icon: 'Dumbbell',
  },
  {
    title: 'GPS Adventure Tracking',
    description: 'Map every ride, run, and hike with heatmaps, segments, and gradient profiles.',
    icon: 'Map',
  },
  {
    title: 'Recovery Intelligence',
    description: 'Muscle-by-muscle recovery insights to train smarter, not harder.',
    icon: 'Activity',
  },
  {
    title: 'Rest Timer',
    description: 'Auto-cued rest periods between sets with adaptive recommendations.',
    icon: 'Timer',
  },
  {
    title: 'Community Routes',
    description: 'Discover and share gravel, road, and trail routes from athletes worldwide.',
    icon: 'Users',
  },
];

export const testimonials = [
  { name: 'Maya R.', role: 'Cat 2 Cyclist', quote: 'Finally one app for the gym and the gravel. My training has never been this dialed.', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80' },
  { name: 'Devin L.', role: 'Powerlifter', quote: 'The AI programming is shockingly good. Feels like having a coach in my pocket.', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=80' },
  { name: 'Sara K.', role: 'Ultra Runner', quote: 'Route discovery + recovery tracking changed how I plan my weeks. 10/10.', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&q=80' },
];
